import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import wNumb from 'wnumb';

export default function () {
  const blockSelector = '.js-range-slider-block';
  const inputSelector = '.js-range-slider-input';
  const inputSelectorFrom = '.js-range-slider-input-from';
  const inputSelectorTo = '.js-range-slider-input-to';
  const rangeSelector = '.js-range-slider';

  const blocks = document.querySelectorAll(blockSelector);

  if (!blocks.length) return;

  blocks.forEach((block) => {
    if (block.closest("fieldset[disabled]")) {
      return;
    }

    if (block.closest("form.application-form--readonly")) {
      return;
    }

    const range = block.querySelector(rangeSelector);

    if (!range) {
      return;
    }

    const rangeOwnerBlock = range.closest(blockSelector);

    if (rangeOwnerBlock && rangeOwnerBlock !== block) {
      return;
    }

    if (range.noUiSlider) {
      return;
    }

    const form = document.querySelector(".js-gallery-filter-form");
    const input = block.querySelector(inputSelector);

    if (input && (input.disabled || input.readOnly)) {
      return;
    }
    const inputFrom = block.querySelector(inputSelectorFrom);
    const inputTo = block.querySelector(inputSelectorTo);

    const isTwoRangeValues = inputFrom && inputTo;
    let start, min, max, step;

    if (isTwoRangeValues) {
      const startFrom = inputFrom.getAttribute('data-start-from');
      const startTo = inputTo.getAttribute('data-start-to');
      min = [+inputFrom.min];
      max = [+inputTo.max];
      step = +inputFrom.step;
      start = [+startFrom, +startTo];
    } else {
      if (!input) {
        return;
      }

      min = [+input.min];
      max = [+input.max];
      step = +input.step;
      start = [+input.value];
    }

    try {
      noUiSlider.create(range, {
      start: start,
      step: step,
      connect: true,
      format: wNumb({
        decimals: 0
      }),
      range: {
        'min': min,
        'max': max
      }
      });
    } catch (error) {
      console.error('Failed to initialize range slider', error);
      return;
    }

    if (!isTwoRangeValues) {
      input?.addEventListener('change', () => {
        range.noUiSlider.set([+input.value]);
      });
    }

    range.noUiSlider.on('update', function (values, handle) {
      if (isTwoRangeValues) {
        inputFrom.value = values[0];
        inputTo.value = values[1];

        if (form) {
          form.dispatchEvent(new Event('change'));
        }
      } else {
        input.value = values[0];
      }
    });
  });
}
